export const API_ENDPOINTS = {
  USERS_LOGIN: "/auth/sign-in",
  AUTH_PROFILE: "/auth/profile",
  AUTH_CHANGE_PASSWORD: "/auth/changePassword",
  CHANGE_PASSWORD: "/admin/password/change",
  USERS_LOGOUT: "/auth/logout",
  AUTH_LOGOUT: "/auth/logout",
  AUTH_FORGOT_PASSWORD: "/auth/forgot-password",
  AUTH_RESET_PASSWORD: "/auth/reset-password",
  GET_USERS_BALANCES: "/admin/user_balances",
  GET_USERS_MONEY_MOVER_BALANCES: "/admin/moneymover_balances",
  GET_DASHBORAD_EXPORT: "/admin/export_user_balance_history",
  DASHBOARD_EXPORT: "/admin/export_dashboard",
  GET_HISTORY_DAY: "/admin/history_start_day",
  GET_USERS: "/admin/users",
  GET_BILLING_CATEGORIES: "admin/money-mover/fees/categories",
  GET_BILLING_SERVICES: "admin/money-mover/fees/services",

  GET_INDIVIDUAL_USERS: "/admin/individual/users",
  GET_BUISINESS_USERS: "/admin/business/users",
  GET_USER: "/admin/user/",
  BLOCK_USER: "/blocked",
  UPDATE_VIP: "/vip",
  GET_USER_TRANSACTIONS: "/transactions",
  GET_USER_TRANSFERS: "/transfers",
  GET_USER_BANKCARDS: "/bank_cards",
  GET_USER_BALANCES: "/balances",
  GET_BANK_ACCOUNTS: "/admin/platform_bank_account",
  GET_INSIVIDUAL_DEPOSIT_TRANSACTIONS: "/admin/individual/payment/deposits",
  TRANSACTION_RECEIPT_PDF: "/admin/receipts/generate",

  GET_BUISINESS_DEPOSIT_TRANSACTIONS: "/admin/business/payment/deposits",
  GET_INDIVIDUAL_WITHDRAWAL_TRANSACTIONS:
    "/admin/individual/payment/withdrawals",
  GET_BUISINESS_WITHDRAWAL_TRANSACTIONS: "/admin/business/payment/withdrawals",
  GET_TRANSFERS: "/admin/payment/transfers",
  GET_INDIVIDUAL_KWICKPAY_TRANSACTIONS:
    "/admin/individual/payment/kwikpay_transactions",
  GET_BUISINESS_KWICKPAY_TRANSACTIONS:
    "/admin/business/payment/kwikpay_transactions",
  GET_INDIVIDUAL_MONEY_MOVERS_TRANSACTIONS:
    "/admin/money-mover/transactions/list/individual",
  GET_BUSINESS_MONEY_MOVERS_TRANSACTIONS:
    "/admin/money-mover/transactions/list/business",
  GOOGLE_2FA_GENERATE_KEY: "/admin/2fa/generate_secret_key",
  GOOGLE_2FA_ENABLE: "/admin/2fa/enable",
  GOOGLE_2FA_DISABLE: "/admin/2fa/disable",
  TWO_FA_STATUS: "/auth/twoFA/status",
  GET_NOTIFICATIONS: "/admin/notifications",
  UPDATE_NOTIFICATION: "/admin/notifications/update",
  GET_ADMINS: "/admin/admins",
  GET_ADMIN: "/admin/admin",
  GET_PERMISSIONS: "/admin/permissions",
  ADD_PERMISSIONS: "/admin/permissions",
  PERMISSIONS: "/permissions",
  PERMISSIONS_ROLES: "/permissions/roles",
  PERMISSIONS_ACTIVE_ROLES: "/permissions/activeRoles",
  PERMISSIONS_DUPLICATE_ROLE: "/permissions/duplicate/role",
  PERMISSIONS_MANAGE_ROLES: "/permissions/manage/roles",
  CHANNEL_PARTNER: "/channel-partner",
  CHANNEL_PARTNER_ACTIVE: "/channel-partner/active",
  WHITE_LABEL_ADMIN_LIST: "/auth/admin/list",
  WHITE_LABEL_ADMIN_ADD: "/auth/admin/add",
  WHITE_LABEL_ADMIN_UPDATE: (id: number | string) => `/auth/admin/update/${id}`,
  WHITE_LABEL_ADMIN_DETAILS: (id: number | string) => `/auth/admin/${id}`,
  WHITE_LABEL_ADMIN_REMOVE: (id: number | string) => `/auth/admin/remove/${id}`,
  GET_CURRENCIES: "/admin/assets",
  GET_LIMITATIONS: "/admin/limits",
  GET_DAILY_LIMITS: "/admin/daily_limits",
  GET_SINGLE_LIMITATIONS: "/admin/limitations/individual/single",
  GET_GUEST_USER_TRANSACTION: "/admin/utility/transactions",

  GET_SINGLE_BILLING_LIMITATIONS: "/admin/money-mover/limitations/list",
  // {{api_endpoint}}/admin/money-mover/fees/list/:user_type

  GET_DAILY_LIMITATIONS: "/admin/limitations/individual/daily",
  GET_SINGLE_EXPORT: "/admin/limitations/individual/export-single",
  GET_DAILY_EXPORT: "/admin/limitations/individual/export-daily",
  GET_SINGLE_BUSINESS_EXPORT: "/admin/limitations/business/export-single",
  GET_DAILY_BUSINESS_EXPORT: "/admin/limitations/business/export-daily",
  GET_SINGLE_BUSINESS_LIMITATIONS: "/admin/limitations/business/single",
  GET_DAILY_BUSINESS_LIMITATIONS: "/admin/limitations/business/daily",
  GET_FEES: "/admin/fees",
  GET_CHANELS: "/admin/channels",
  GET_FEES_INDIVIDUAL: "/admin/fees-management/individual/ranges-percent",
  GET_FEES_INDIVIDUAL_PERCENT:
    "/admin/fees-management/individual/range/percent",
  GET_BILLING_FEES: "/admin/money-mover/fees/list",
  GET_PRE_LOGIN_FEES: "/admin/utility/commissions",
  GET_PRE_LOGIN_FEES_EXPORT: "/admin/utility/transactions/export?format=csv",

  GET_FEES_BUSINESS: "/admin/fees-management/business/ranges-percent",
  GET_FEES_BUSINESS_PERCENT: "/admin/fees-management/business/range/percent",
  GET_FIAT_LIST: "/admin/fiat-list",
  GET_FEES_INDIVIDUAL_EXPORT:
    "/admin/fees-management/individual/export-range-percent",
  GET_FEES_BUSINESS_EXPORT:
    "/admin/fees-management/business/export-range-percent",
  GET_INDIVIDUAL_PENDING_DEPOSIT: "/admin/individual/payment/deposits/pending",
  CONFIRM_INDIVIDUAL_PENDING_DEPOSIT:
    "/admin/individual/payment/deposit/complete",
  CANCEL_INDIVIDUAL_PENDING_DEPOSIT: "/admin/individual/payment/deposit/cancel",
  GET_BUSINESS_PENDING_DEPOSIT: "/admin/business/payment/deposits/pending",
  CONFIRM_BUSINESS_PENDING_DEPOSIT: "/admin/business/payment/deposit/complete",
  CANCEL_BUSINESS_PENDING_DEPOSIT: "/admin/business/payment/deposit/cancel",
  GET_UNIDENTIFIED_DEPOSITS: "/admin/bank_transfer/unknown_deposits",
  CONFIRM_UNIDENTIFIED_DEPOSIT: "/admin/bank_transfer/unknown_deposits/confirm",
  REJECT_UNIDENTIFIED_DEPOSIT: "/admin/bank_transfer/unknown_deposits/reject",
  FIND_USER: "/admin/bank_transfer/find_user",
  GET_INDIVIDUAL_PENDING_WITHDRAWAL:
    "/admin/individual/payment/withdrawals/pending",
  CONFIRM_INDIVIDUAL_PENDING_WITHDRAWAL:
    "/admin/individual/payment/withdrawal/complete/V2",
  CANCEL_INDIVIDUAL_PENDING_WITHDRAWAL:
    "/admin/individual/payment/withdrawal/cancel/V2",
  GET_BUSINESS_PENDING_WITHDRAWAL:
    "/admin/business/payment/withdrawals/pending",
  CONFIRM_BUSINESS_PENDING_WITHDRAWAL:
    "/admin/business/payment/withdrawal/complete/V2",
  CANCEL_BUSINESS_PENDING_WITHDRAWAL:
    "/admin/business/payment/withdrawal/cancel/V2",
  GET_INDIVIDUAL_USER: "/admin/individual/user",
  OUR_PRICES: "/admin/our-prices",
  GET_RESET2FA_LIST: "/admin/2fa/reset",
  GET_RESET2FA_REJECT: "/admin/2fa/reject",
  GET_EMAIL_HISTORY_LIST: "/admin/email-2fa-history",
  GET_SMS_HISTORY_LIST: "/admin/sms-2fa-history",
  PUT_RISK_LELVEL_INDIVIDUAL: (id: number) =>
    `admin/individual/user/${id}/risk_level`,
  PUT_RISK_LELVEL_BUISINESS: (id: number) =>
    `admin/business/user/${id}/risk_level`,
  GET_USER_INDIVIDUAL_LIMITATIONS: (id: number) =>
    `/admin/individual/user/${id}/limitations`,
  GET_USER_DAILY_INDIVIDUAL_LIMITATIONS: (id: number) =>
    `/admin/individual/user/${id}/daily_limitations`,
  GET_USER_BUISNESS_LIMITATIONS: (id: number) =>
    `/admin/business/user/${id}/limitations`,
  GET_USER_DAILY_BUISNESS_LIMITATIONS: (id: number) =>
    `/admin/business/user/${id}/daily_limitations`,
  USER_INDIVIDUAL_LIMITATION_SETTINGS: (id: number) =>
    `/admin/individual/user/${id}/limitation_settings`,
  USER_BUISNESS_LIMITATION_SETTINGS: (id: number) =>
    `/admin/business/user/${id}/limitation_settings`,

  USER_LIMITATION_SETTINGS: (id: number) => `users/limit/settings/${id}`,

  UDPATE_USER_UML_STATUS: (id: number) =>
    `/admin/individual/user/${id}/aml_status`,
  UDPATE_BUISINESS_UML_STATUS: (id: number) =>
    `/admin/business/user/${id}/aml_status`,
  // UPDATE_INDIVIDUAL_USER_VIP: (id: number) =>
  //   `/admin/individual/user/${id}/vip`,
  UPDATE_USER_VIP_STATUS: (id: number) => `/activity-logs/${id}/vip-status`,
  // ----------------
  UPDATE_USER_AGENCY_STATUS: `/users/update-agency-status`, //`/admin/agency-request-verify`,
  // -------------------
  // UPDATE_BUISINESS_USER_VIP: (id: number) => `/admin/business/user/${id}/vip`,
  UPDATE_2FA_USER: (id: number | string) =>
    `/users/update-2faStatusMethod/${id}`,

  GET_INDIVIDUAL_BANK_CARDS: (id: number) =>
    `/admin/individual/user/${id}/bank_cards`,
  GET_INDIVIDUAL_IBAN_ACCOUNTS: (id: number, account_type?: string) =>
    `/admin/individual/user/${id}/iban_accounts/${account_type}`,
  GET_BUISINESS_BANK_CARDS: (id: number) =>
    `/admin/business/user/${id}/bank_cards`,
  GET_BUISINESS_IBAN_ACCOUNTS: (id: number, account_type?: string) =>
    `/admin/business/user/${id}/iban_accounts/${account_type}`,
  GET_INDIVIDUAL_USET_SETTINGS: (id: number) =>
    `/admin/individual/user/${id}/user_settings`,
  GET_BUISINESS_USET_SETTINGS: (id: number) =>
    `/admin/business/user/${id}/user_settings`,
  GET_INDIVIDUAL_USER_BALANCES: (id: number) =>
    `/admin/individual/user/${id}/balances`,
  GET_BUISINESS_USER_BALANCES: (id: number) =>
    `/admin/business/user/${id}/balances`,
  GET_INDIVIDUAL_USER_TRANSACTIONS: (id: number) =>
    `/admin/individual/user/${id}/transactions`,
  GET_BUISINESS_USER_TRANSACTIONS: (id: number) =>
    `/admin/business/user/${id}/transactions`,
  GET_BUISINESS_MTS_USER_TRANSACTIONS: (id: number) =>
    `/admin/business/user/${id}/transactions?type=mts`,
  GET_USERS_BLCKED: (type: string) => `/admin/${type}/user`,
  // GET_USERS_BLCKED: (type: string, id: number) =>
  //   `/auth/${type}/user/${id}/blocked`,

  GET_MTS_LIST: "/admin/mts/transactions/list",
  GET_CATEGORIES_LIST: "/admin/money-mover/categories/list",
  ADD_CATEGORY: "/admin/money-mover/categories/add",
  GET_CATEGORIEY_DETAILS: "/admin/money-mover/categories",
  UPDATE_CATEGORY: "/admin/money-mover/categories/update",
  DELETE_CATEGORY: "/admin/money-mover/categories",
  GET_SERVICES_LIST: "/admin/money-mover/services/list",

  GET_CASHOUT_SERVICES_LIST: "/admin/money-mover/cashout-services/list",
  ADD_CASHOUT_SERVICE: "/admin/money-mover/cashout-services/add",
  UPDATE_CASHOUT_SERVICE: "/admin/money-mover/cashout-services/update",
  GET_CASHOUT_SERVICE_DETAILS: "/admin/money-mover/cashout-services",
  DELETE_CASHOUT_SERVICE: "/admin/money-mover/cashout-services",

  ADD_SERVICE: "/admin/money-mover/services/add",
  GET_SERVICE: "/admin/money-mover/services",
  UPDATE_SERVICE: "/admin/money-mover/services/update",
  DELETE_SERVICE: "/admin/money-mover/services",
  UPDATE_SERVICE_CATEGORY: "/admin/money-mover/services",

  GET_LANGUAGES: "/admin/translations/languages",
  GET_ALL_MODULES: "/admin/translations/modules",
  GET_MODULE_DETAILS: "/admin/translations/module",
  UPDATE_MODULE_TRANSLATION: "/admin/translations/module",
  GLOBAL_SEARCH_TRANSLATION: "admin/translations/search",
  ADD_TRANSLATION_FILE: "admin/utility/language/upload",
  GET_CONVERSIONS_LIST: "/convertion-rate",
  GET_CONVERSION_ORDER_LIST: (type: string) =>
    `/admin/conversion/${type}/orders`,
  GET_USER_CONVERSION_ORDER_LIST: (user_type: string) =>
    `/admin/conversion/orders/user/${user_type}`,
  EXPORT_USER_CONVERSION_ORDER_LIST: (type: string) =>
    `/admin/conversion/${type}/orders/export`,
  GET_PROVIDER_LIST: "/admin/kiosks/list",
  GET_PROVIDER_TRANSACTIONS: "/admin/kiosks/history",
  CREATE_PROVIDER: "admin/kiosks/create",
  UPDATE_PROVIDER: (id: Number) => `admin/kiosks/${id}/update-status`,
  REMOVE_PROVIDER: (id: number) => `admin/kiosks/${id}/delete`,
  GET_ADMIN_ACTIVITY_LIST: "admin/activity-logs",
  GET_ADMIN_ACTIVITY_LOGS: "/activity-logs/history",

  GET_WTW_INDIVIDUAL_TRANSACTIONS_LIST: `/admin/wallet/individual/transactions`,
  GET_WTW_BUSINESS_TRANSACTIONS_LIST: `/admin/wallet/business/transactions`,
  GET_INDIVIDUAL_USER_W2W_TRANSACTIONS: (id: number) =>
    `/admin/wallet/transactions/individual/${id}`,
  GET_BUSINESS_USER_W2W_TRANSACTIONS: (id: number) =>
    `/admin/wallet/transactions/business/${id}`,
  EXPORT_WALLET_TRANSACTION_LIST: (type: string) =>
    `admin/wallet-transfer/${type}/transactions/export`,

  // Admin alert APIs
  GET_ALL_ALERT_NOTIFICATIONS: "/notification/getAll",
  UPDATE_ALERT_NOTIFICATIONS: (id: number) => `/notification/update/${id}`,

  // Manual transfer API's
  GET_MANUAL_INDIVIDUAL_PENDING: "/admin/manual-transaction/individual/pending",
  GET_MANUAL_BUSINESS_PENDING: "/admin/manual-transaction/business/pending",
  CANCEL_MANUAL_TRANSFER: "/admin/manual-transaction/cancel/request", //POST
  APPROVE_MANUAL_TRANSFER: "/admin/manual-transaction/approve/request", //POST

  CREATE_MAUAL_TRANSFER: "/admin/manual-transaction/create", // create manual transfer
  GET_MANUAL_TRANSFER_CURRENCIES: "/admin/manual-transaction/currencies", // get manual transaction currencies
  FIND_USER_FOR_MANUAL_TRANSACTION: "/admin/manual-transaction/find-user", // Find user /admin/manual-transaction/find-user

  // notification/email template API's
  GET_ALL_EMAIL_TEMPLATES: "/email-template",
  UPDATE_EMAIL_TEMPLATE: (id: number) => `/email-template/${id}`,
  ADD_EMAIL_TEMPLATE: "/email-template",

  //Update balance
  UPDATE_FROZEN_BALANCE: "/users/move/frozen",
  REMOVE_FROZEN_BALANCE: "/users/remove/frozen",
  REMOVE_MAIN_BALANCE: "/users/remove/main",

  // wallet terminal API's
  WALLET_TERMINALS: "/wallet-terminals",
  // ADD_WALLET_TERMINAL: "/wallet-terminals",
  // UPDATE_WALLET_TERMINAL: "/wallet-terminals",
  // REMOVE_WALLET_TERMINAL: "/wallet-terminals",
  GET_WALLET_TERMINAL_TRANSACTIONS_LIST: `/wallet-terminals/transaction/history`,
  EXPORT_WALLET_TERMINAL_TRANSACTION_LIST: `/wallet-terminals/export/history`,
  VIEW_WALLET_TERMINAL_HISTORY_LOGS: `/wallet-terminals/history/logs`,
  //Fees and limitations APIS
  GET_CHANNEL_LIST: "/fees/channel/list",
  GET_FEES_LIST: "/fees",
  UPDATE_FEES: `/fees`,
  GET_LIMITATION_LIST: "/fees/limits/list",
  UPDATE_LIMITATIONS: `/fees/limits/:id`,
  GET_DAILY_LIMIT_LIST: "/fees/daily-limits/list",
  UPDATE_DAILY_LIMIT: `/fees/daily-limits/:id`,
  //Add limits
  ADD_LIMITS_NEW: `/fees/limits/add`,
  ADD_DAILY_LIMITS_NEW: `/fees/daily-limits/add`,
  //Service maintenance
  GET_ALL_SERVICES_LIST: "/service-maintenance",
  UPDATE_SERVICES: (id: number) => `/service-maintenance/${id}`,
  GLOBAL_MAINTENANCE: `/service-maintenance/global-maintenance`,
  //Service alert
  GET_ALL_SERVICES_ALERTS_LIST: "/alert-service",
  UPDATE_SERVICES_ALERTS: (id: number) => `/alert-service/${id}`,
  //Service incidents
  GET_ALL_SERVICES_INCIDENTS_LIST: "/alert-service/incident",
  UPDATE_SERVICE_INCIDENT: (id: number) =>
    `alert-service/incident/${id}/resolve`,
  //New user kyc info apis
  GET_USER_KYC_INFO_DOCS: (id: number) => `/users/kyc/info/${id}`,
  GET_USER_KYC_INFO_IMAGES: (id: number) => `/users/signed/link/${id}`,
  GET_USER_KYC_INFO_EVENTS: (id: number) => `/users/kyc/events/${id}`,
  GET_USER_INFO_CONSENT: (id: number) => `/users/consent/data/${id}`,
  GET_USER_KYC_INFO_QUESTIONNAIRE: (id: number) =>
    `/users/questionnaire/data/${id}`,

  //Card packages
  GET_CARD_PACKAGES_LIST: "/packages",
  ADD_CARD_PACKAGES: "/packages/create",
  VIEW_PARTICULAR_PACKAGE: (id: number) => `/packages/view/${id}`,
  UPDATE_CARD_PACKAGES: (id: number) => `/packages/update/${id}`,
  DELETE_CARD_PACKAGES: (id: number) => `/packages/delete/${id}`,

  // Card Products
  GET_CARD_PRODUCTS_LIST: "/card-management/card-product",
  ADD_CARD_PRODUCT: "/card-management/card-product",
  VIEW_PARTICULAR_PRODUCT: (id: number) =>
    `/card-management/card-product/${id}`,
  UPDATE_CARD_PRODUCT: (id: number) => `/card-management/card-product/${id}`,
  DELETE_CARD_PRODUCT: (id: number) => `/card-management/card-product/${id}`,

  // Card terms conditions
  GET_CARD_TERMS_CONDITIONS_LIST: "/card-management/card-condition",
  ADD_CARD_TERMS_CONDITIONS: "/card-management/card-condition",
  VIEW_PARTICULAR_TERMS_CONDITIONS: (id: number) =>
    `/card-management/card-condition/${id}`,
  UPDATE_CARD_TERMS_CONDITIONS: (id: number) =>
    `/card-management/card-condition/${id}`,
  DELETE_CARD_TERMS_CONDITIONS: (id: number) =>
    `/card-management/card-condition/${id}`,

  //Card merchants
  GET_CARD_MERCHANTS_LIST: "/card-management/merchant/get-all",
  ADD_CARD_MERCHANT: "/card-management/merchant",
  VIEW_PARTICULAR_MERCHANT: `/card-management/merchant/get-by-id`,
  CREATE_MERCHANT_API_KEY: `/card-management/merchant/create-api-keys`,
  REVOKE_MERCHANT_API_KEY: `/card-management/merchant/revoke-api-keys`,
  ADD_MERCHANT_IP_WHITELIST: `/card-management/merchant/ip-whitelist`,
  DELETE_MERCHANT_IP_WHITELIST: ``,

  //Card conversion rates
  GET_ALL_CONVERSION_CURRENCY_RATES: "/card-management/currency-rates",
  GET_ALL_CONVERSION_CURRENCY_RATES_HISTORY:
    "/card-management/get-currency-rate-sync-history",
  UPDATE_CARD_CURRENCY_MARGIN: "/card-management/update-currency-margin",
  SYNC_CONVERSION_CURRENCY_RATES: "/card-management/sync-currency-rates",
  GET_ALL_CARD_TRANSACTIONS: "/card-management/merchant/get-all-transactions",

  //Card types
  GET_CARD_TYPES_LIST: "/card-management/card-type",
  ADD_CARD_TYPES: "/card-management/card-type",
  VIEW_PARTICULAR_CARD_TYPE: (id: number) => `/card-management/card-type/${id}`,
  UPDATE_CARD_TYPES: (id: number) => `/card-management/card-type/${id}`,
  DELETE_CARD_TYPES: (id: number) => `/card-management/card-type/${id}`,

  // Card billings
  GET_CARD_BILLINGS_LIST: "/card-management/all-card-billings",

  // Get user cards list
  GET_USERS_VIRTUAL_CARDS_LIST: (id: number) =>
    `/card-management/user-cards/${id}`,
  BLOCK_USER_VIRTUAL_CARD: "/card-management/block-card",
  UNBLOCK_USER_VIRTUAL_CARD: "/card-management/unblock-card",
  CLOSE_USER_VIRTUAL_CARD: "/card-management/cancel-card",
  GENERATE_USER_VIRTUAL_CARD_PIN: "/card-management/generate-pin",
  ENABLE_GAMBLING_USER_VIRTUAL_CARD: "/card-management/enable-gambling",
  DISABLE_GAMBLING_USER_VIRTUAL_CARD: "/card-management/disable-gambling",
  GET_USER_DETAILS_BY_CARD_ID: (id: number) =>
    `/card-management/user-details/${id}`,

  // Card pool
  GET_CARD_POOL_SUMMARY: "/card-management/card-pool-summary",
  GENERATE_CARD_POOL: "/card-management/generate-card-pool",

  //
  GET_ALL_ORDERED_CARDS: "/card-management/all-cards",
  GET_KAFKA_NOTIFICATIONS: "/card-management/kafka-notifications",
  GET_KAFKA_SYNC_HISTORY: "/users/sync/kafka-notifications",

  //Sync user card balances
  SYNC_USER_CARD_BALANCES_LIST: `/users/sync/requests`,
  SYNC_FASTOO_TO_BANK_BALANCE: `/users/fastoo/bank`,
  SYNC_BANK_TO_FASTOO_WALLET_BALANCE: `/users/bank/fastoo`,

  //Landing-page
  FAQ_MANAGEMENT: `/landing-page/faqs`,
  BLOG_MANAGEMENT: `/landing-page/blogs`,
  UPLOAD_IMAGE: `landing-page/upload-image`,
  UPLOAD_IMAGE_WHITE_LABEL: `auth/upload-image`,

  // New transactions history and exports history
  PAYMENTS_TRANSACTIONS_HISTORY: "/payments/payments",
  PAYMENTS_TRANSACTIONS_EXPORT_PDF: "/exports/export-payment-pdf",
  PAYMENTS_TRANSACTIONS_EXPORT_EXCEL: "/exports/export-payment-excel",
  PAYMENTS_TRANSACTIONS_HISTORY_DROPDOWNS: "/payments/payment-dropdowns",

  EXPORTS_HISTORY_LIST: "/exports",
  DOWNLOAD_EXPORT_LIST: "/exports/download-payment-transaction",

  // User activity logs
  GET_USER_ACTIVITY_LOGS: "/activity-logs/audit-logs",
  GET_USER_ACTIVITY_LOG_ACTIONS: "/activity-logs/audit-logs/actions",

  // mts transfer logs
  GET_MTS_TRANSFER_LOGS: "/wallet-terminals/mts/logs",

  // Update user endpoints
  UPDATE_INDIVIDUAL_USER: (id: number | string) =>
    `/users/update-individual-user/${id}`,
  UPDATE_BUSINESS_USER: (id: number | string) =>
    `/users/update-business-user/${id}`,
};
